import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-401910c9")

_pushScopeId("data-v-401910c9")
const _hoisted_1 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_2 = {
  key: 1,
  style: {"margin-left":"10px"}
}
const _hoisted_3 = {
  key: 2,
  style: {"margin-left":"10px"}
}
const _hoisted_4 = {
  key: 3,
  style: {"margin-left":"10px"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("管理")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "el-dropdown-link" }, [
  /*#__PURE__*/_createTextVNode(" 更多"),
  /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = { style: {"text-align":"right","margin-top":"10px"} }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "确认删除应用吗？", -1)
const _hoisted_11 = { class: "dialog-footer" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确 定")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_table, {
      data: _ctx.applications.rows,
      key: _ctx.reflush,
      "empty-text": "暂无数据",
      style: {"width":"100%"}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "应用名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "APPID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "shelfState",
          label: "当前状态"
        }, {
          default: _withId((scope) => [
            (scope.row.shelfState=='0')
              ? (_openBlock(), _createBlock("span", _hoisted_1, "未上架"))
              : (scope.row.shelfState=='1' && scope.row.examineState=='0')
                ? (_openBlock(), _createBlock("span", _hoisted_2, "信息维护中"))
                : (scope.row.shelfState=='1' && scope.row.examineState=='1')
                  ? (_openBlock(), _createBlock("span", _hoisted_3, "已上架"))
                  : (scope.row.shelfState=='2')
                    ? (_openBlock(), _createBlock("span", _hoisted_4, "已下架"))
                    : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "categoryName",
          label: "应用类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "terminalType",
          label: "适用终端"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "150"
        }, {
          default: _withId((scope) => [
            _createVNode(_component_el_button, {
              onClick: $event => (_ctx.manageApp(scope.row)),
              type: "text"
            }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              onClick: $event => (_ctx.editApp(scope.row)),
              type: "text"
            }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.shelfState==3 && scope.row.shelfState=='0')
              ? (_openBlock(), _createBlock(_component_el_dropdown, {
                  key: 0,
                  style: {"margin-left":"10px","color":"#2574FF"}
                }, {
                  dropdown: _withId(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_dropdown_item, {
                          onClick: $event => (_ctx.wantDelApp(scope.$index))
                        }, {
                          default: _withId(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        currentPage: _ctx.page,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => (_ctx.page = $event)),
        total: _ctx.applications.total_rows,
        onCurrentChange: _ctx.getApplications
      }, null, 8, ["currentPage", "total", "onCurrentChange"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "提示",
      modelValue: _ctx.delDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.delDialogVisible = $event)),
      width: "30%",
      "close-on-click-modal": _ctx.clickModalClose,
      "before-close": _ctx.handleClose
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.delDialogVisible = false))
          }, {
            default: _withId(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.delApp
          }, {
            default: _withId(() => [
              _hoisted_13
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withId(() => [
        _hoisted_10
      ]),
      _: 1
    }, 8, ["modelValue", "close-on-click-modal", "before-close"])
  ], 64 /* STABLE_FRAGMENT */))
})